module.exports = __webpack_public_path__ + "static/media/bankSlip.fded29db.png";